import { BASE_URL, requests } from "./base"

const GET_STATS = `${BASE_URL}/admin/stats`

export const getStats = async () => {
  const res = await requests.get<StatsCounters>(GET_STATS)
  return res
}
